import React from 'react';

import { HGATE_INCLUDED } from '../../../../shared/env';
import { useUserState } from '../../../../shared/hooks/accountHook';

import { Landing as LandingDefault } from './Landing';
import { Landing as LandingEN } from './LandingEN';

export const Landing = () => {
  const [user] = useUserState();
  return (!user || user?.identified) && HGATE_INCLUDED ? (
    <LandingDefault />
  ) : (
    <LandingEN />
  );
};
